module.exports = __webpack_public_path__ + "static/media/VIIIe.0ddf7b47.png";